// Format nomor identitas berdasarkan jenis
export const formatIdNumber = (value: string, idType: string): string => {
  if (!value) return '';

  // Hanya angka untuk KTP dan NPWP
  if (idType === 'ktp' || idType === 'npwp') {
    return value.replace(/\D/g, '');
  }

  // Alphanumeric untuk Passport dan SIUP
  if (idType === 'passport' || idType === 'siup') {
    return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }

  return value;
};

// Format NPWP dengan titik dan strip
export const formatNPWP = (value: string): string => {
  // Hapus semua karakter non-digit
  const digits = value.replace(/\D/g, '');

  // Format: XX.XXX.XXX.X-XXX.XXX
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 9)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}.${digits.slice(8)}`;
  if (digits.length <= 12)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}.${digits.slice(8, 9)}-${digits.slice(9)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}.${digits.slice(8, 9)}-${digits.slice(9, 12)}.${digits.slice(12, 15)}`;
};

// Konfigurasi untuk setiap jenis identitas
export const getIdNumberConfig = (idType: string) => {
  switch (idType) {
    case 'ktp':
      return {
        maxLength: 16,
        placeholder: 'Masukkan 16 digit nomor KTP',
        pattern: '^[0-9]{16}$',
        errorMessage: 'Nomor KTP harus 16 digit angka',
        formatHint: 'Format: 16 digit angka',
      };
    case 'passport':
      return {
        maxLength: 15,
        placeholder: 'Contoh: A1234567 atau AB123456',
        pattern: '^[A-Z0-9]{6,15}$',
        errorMessage: 'Nomor paspor harus 6-15 karakter alfanumerik',
        formatHint: 'Format: 6-15 karakter alfanumerik',
      };
    case 'npwp':
      return {
        maxLength: 20, // Untuk format dengan titik dan strip
        placeholder: 'Contoh: 12.345.678.9-012.345',
        pattern: '^[0-9]{2}\\.[0-9]{3}\\.[0-9]{3}\\.[0-9]{1}-[0-9]{3}\\.[0-9]{3}$',
        errorMessage: 'Format NPWP: XX.XXX.XXX.X-XXX.XXX',
        formatHint: 'Format: XX.XXX.XXX.X-XXX.XXX (15 digit)',
      };
    case 'siup':
      return {
        maxLength: 20,
        placeholder: 'Contoh: SIUP123456789',
        pattern: '^[A-Z0-9]{6,20}$',
        errorMessage: 'Nomor SIUP harus 6-20 karakter alfanumerik',
        formatHint: 'Format: 6-20 karakter alfanumerik',
      };
    default:
      return {
        maxLength: 50,
        placeholder: 'Nomor identitas',
        pattern: '',
        errorMessage: '',
        formatHint: '',
      };
  }
};

// Validasi nomor identitas
export const validateIdNumber = (value: string, idType: string): string => {
  if (!value) return '';

  if (idType === 'ktp') {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 16) {
      return 'Nomor KTP harus 16 digit';
    }
  }

  if (idType === 'npwp') {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 15) {
      return 'NPWP harus 15 digit';
    }
  }

  if (idType === 'passport') {
    if (value.length < 6 || value.length > 15) {
      return 'Nomor paspor harus 6-15 karakter';
    }
    if (!/^[A-Z0-9]{6,15}$/i.test(value)) {
      return 'Nomor paspor hanya boleh berisi huruf dan angka';
    }
  }

  if (idType === 'siup') {
    if (value.length < 6 || value.length > 20) {
      return 'Nomor SIUP harus 6-20 karakter';
    }
    if (!/^[A-Z0-9]{6,20}$/i.test(value)) {
      return 'Nomor SIUP hanya boleh berisi huruf dan angka';
    }
  }

  return '';
};
